<template>
    <div class="tabMaterials">
        <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="中草药" name="medicines" :key="'medicines'">
                <child1 v-if="isChildUpdate1"></child1>
            </el-tab-pane>
    
            <el-tab-pane label="西药/中成药" name="products" :key="'products'">
                <child2 v-if="isChildUpdate2"></child2>    
            </el-tab-pane>
             <el-tab-pane label="器械" name="apparatus" :key="'apparatus'">
                <child3 v-if="isChildUpdate3"></child3>    
            </el-tab-pane>
        </el-tabs>
        
    </div>
</template>

<script>
import tabMaterialsStockMedicine from '@/tabComponents/tabMaterialsStockMedicine'
import tabMaterialsStockProduct from '@/tabComponents/tabMaterialsStockProduct'
import tabMaterialsStockApparatus from '@/tabComponents/tabMaterialsStockApparatus'
export default {
    name: 'tabMaterialsStock',
    components:{
        child1:tabMaterialsStockMedicine,
        child2:tabMaterialsStockProduct,
        child3:tabMaterialsStockApparatus
    },
    data() {
        return {
            //默认第一个选项卡
            activeName: "medicines",
            isChildUpdate1:true,
            isChildUpdate2:false,
            isChildUpdate3:false
        }
    },
    
   
    methods:{
        handleClick(tab) {
            if(tab.name == "medicines") {
                this.isChildUpdate1 = true;
                this.isChildUpdate2 = false;
                 this.isChildUpdate3 = false;
            } else if(tab.name == "products") {
                this.isChildUpdate1 = false;
                this.isChildUpdate2 = true;
                this.isChildUpdate3 = false;
            }else if(tab.name == "apparatus"){
                this.isChildUpdate1 = false;
                this.isChildUpdate2 = false;
                this.isChildUpdate3 = true;
            }
        },
        

    }
}
</script>